import './style.css';

const Spinner = () => (
    <div className='spinner' />
);

export default Spinner;